/* eslint-disable i18next/no-literal-string */
import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./switch.module.scss";
import classnames from "classnames";
import type { BaseswitchProps } from "@whatslly/types/UI-V2/BaseElements/SwitchType";
import globalStyles from "../../globalStyles";

export const Switch: React.FC<BaseswitchProps> = ({
  paddingInline,
  borderColor,
  marginTop,
  // backgroundColor,
  marginBottom,
  className,
  checked,
  name,
  // notChackedBackGroundColor,
  disabled,
  padding,
  scale,
  replceIconWithText,
  // iconColor,
  // circleColor,
  onChange,
  testId,
}) => {
  const [checkedState, setCheckedState] = useState<boolean>(checked ?? false);
  const inputRef = useRef<HTMLInputElement>(null);
  const tuvisOnChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange) {
        return onChange(e);
      }
      setCheckedState(e.target.checked);
    },
    [onChange]
  );

  const handleOnClick = useCallback(
    (event: React.MouseEvent) => {
      event.preventDefault();
      if (!inputRef.current || name) {
        return;
      }
      inputRef.current.click();
    },
    [name]
  );

  useEffect(() => {
    setCheckedState(checked ?? false);
  }, [checked]);
  return (
    <div
      data-testid={testId}
      className={classnames(
        styles.checkBoxSwitchContainer,
        globalStyles[`p-${padding ?? "none"}`],
        globalStyles[`pi-${paddingInline ?? "small"}`],
        globalStyles[`mb-${marginBottom ?? "none"}`],
        globalStyles[`mt-${marginTop ?? "none"}`],
        className,
        { [styles.disabled]: disabled }
      )}
    >
      <input
        data-testid={`${testId ? `${testId}-input` : ""}`}
        className={styles.reactSwitchCheckbox}
        id={name}
        type="checkbox"
        name={name ?? ""}
        onChange={tuvisOnChange}
        readOnly={!onChange}
        ref={inputRef}
        checked={checkedState}
        disabled={disabled}
      />
      <label
        onClick={handleOnClick}
        className={classnames(styles.reactSwitchLabel, globalStyles[`switch-${scale ?? "default"}`], globalStyles[`bc-${borderColor ?? ""}`], {
          [styles.disabled]: disabled,
          [globalStyles[`switch-background-active-bg-color`]]: checkedState,
          [globalStyles[`switch-background-bg-color`]]: !checkedState,
          [styles.labelWithText]: replceIconWithText,
        })}
        htmlFor={name}
      >
        {replceIconWithText && (
          <>
            <div className={classnames(styles.onText, globalStyles["switch-on-text-color"])}>ON</div>
            <div className={classnames(styles.offText, globalStyles["switch-off-text-color"])}>OFF</div>
          </>
        )}
        <span className={classnames(styles.reactSwitchButton, globalStyles["switch-circle-bg-color"])}>
          {!replceIconWithText && checkedState && (
            <svg viewBox="0 0 7 6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className={globalStyles[`switch-icon-color`]}>
              <path d="M2.37373 3.76321L0.871111 2.23677L0.119812 2.99999L2.37373 5.2897L6.13019 1.47355L5.3789 0.710327L2.37373 3.76321Z" />
            </svg>
          )}
        </span>
      </label>
    </div>
  );
};
